const textLimits = {

	textAreaCharLimit: 10000,
    textInputCharLimitStandard: 300,
    textInputCharLimitExtra: 500,

}

export default textLimits